<template>
    <div id="internalFailure">

        <v-stepper-content step="4">

            <v-jumbotron color="#FF4560" dark>
                <v-container fill-height>
                    <v-layout align-center>
                        <v-flex text-xs-center>
                            <h4 class="display-1">External Failure</h4>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-jumbotron>

            <!-- LOST CUSTOMERS -->
            <v-layout row justify-space-around>
                <v-btn :color=verified.lostCustomers class="subcost" @click="visible.lostCustomers = !visible.lostCustomers">Lost Customers</v-btn>
            </v-layout>

            <v-layout row wrap justify-space-around v-if="visible.lostCustomers">
                <v-flex class="cell" v-for="(cost, i) in externalFailure.lostCustomers" xs6 sm4>
                    <v-text-field
                        :label="cost.name"
                        v-model="cost.value"
                        type="number"
                        @keyup="calculateSubTotal('lostCustomers')"
                    >
                    </v-text-field>
                </v-flex>
            </v-layout>

            <!-- RETURNS -->
            <v-layout row justify-space-around>
                <v-btn :color=verified.returns class="subcost" @click="visible.returns = !visible.returns">Returns</v-btn>
            </v-layout>
            
            <v-layout row wrap justify-space-around v-if="visible.returns">
                <v-flex class="cell" v-for="(cost, i) in externalFailure.returns" xs6 sm4>
                    <v-text-field
                        :label="cost.name"
                        v-model="cost.value"
                        type="number"
                        @keyup="calculateSubTotal('returns')"
                    >
                    </v-text-field>
                </v-flex>
            </v-layout>

            <!-- RECALLS -->
            <v-layout row justify-space-around>
                <v-btn :color=verified.recalls class="subcost" @click="visible.recalls = !visible.recalls">Recalls</v-btn>
            </v-layout>
            
            <v-layout row wrap justify-space-around v-if="visible.recalls">
                <v-flex class="cell" v-for="(cost, i) in externalFailure.recalls" xs6 sm4>
                    <v-text-field
                        :label="cost.name"
                        v-model="cost.value"
                        type="number"
                        @keyup="calculateSubTotal('recalls')"
                    >
                    </v-text-field>
                </v-flex>
            </v-layout>

            <!-- FIELD SERVICES -->
            <v-layout row justify-space-around>
                <v-btn :color=verified.fieldServices class="subcost" @click="visible.fieldServices = !visible.fieldServices">Field Services</v-btn>
            </v-layout>
            
            <v-layout row wrap justify-space-around v-if="visible.fieldServices">
                <v-flex class="cell" v-for="(cost, i) in externalFailure.fieldServices" xs6 sm4>
                    <v-text-field
                        :label="cost.name"
                        v-model="cost.value"
                        type="number"
                        @keyup="calculateSubTotal('fieldServices')"
                    >
                    </v-text-field>
                </v-flex>
            </v-layout>

            <!-- AFTER DELIVERY / REACHES CUSTOMER -->
            <v-layout row justify-space-around>
                <v-btn :color=verified.afterDelivery class="subcost" @click="visible.afterDelivery = !visible.afterDelivery">After Delivery / Reaches Customer</v-btn>
            </v-layout>
            
            <v-layout row wrap justify-space-around v-if="visible.afterDelivery">
                <v-flex class="cell" v-for="(cost, i) in externalFailure.afterDelivery" xs6 sm4>
                    <v-text-field
                        :label="cost.name"
                        v-model="cost.value"
                        type="number"
                        @keyup="calculateSubTotal('afterDelivery')"
                    >
                    </v-text-field>
                </v-flex>
            </v-layout>

            <br>
            <h2>Total External Failure Costs: ${{ total }}</h2>
            <br>

            <v-btn flat @click.native="$emit('previous-step')">Previous</v-btn>
            <v-btn color="primary" @click.native="$emit('sections-complete', [externalFailure, 'externalFailure'])">Continue</v-btn>

        </v-stepper-content>

    </div>
</template>

<script>
    export default {
        name: 'internalFailure',
        props: [
            'total',
            'visible',
            'verified'
        ],
        data: () => ({
            errors: [],
            externalFailureTotal: 0,
            externalFailureSubTotals: {
                lostCustomers: 0,
                returns: 0,
                recalls: 0,
                fieldServices: 0,
                afterDelivery: 0
            },
            externalFailure: {
                lostCustomers: [
                    {
                        name: 'Design Engineering',
                        value: null
                    },
                    {
                        name: 'Purchasing',
                        value: null
                    },
                    {
                        name: 'Production',
                        value: null
                    },
                    {
                        name: 'Accounting',
                        value: null
                    },
                    {
                        name: 'Finance',
                        value: null
                    },
                    {
                        name: 'Quality',
                        value: null
                    },
                    {
                        name: 'Materials',
                        value: null
                    },
                    {
                        name: 'Sales & Marketing',
                        value: null
                    },
                    {
                        name: 'Other',
                        value: null
                    }
                ],
                returns: [
                    {
                        name: 'Design Engineering',
                        value: null
                    },
                    {
                        name: 'Purchasing',
                        value: null
                    },
                    {
                        name: 'Production',
                        value: null
                    },
                    {
                        name: 'Accounting',
                        value: null
                    },
                    {
                        name: 'Finance',
                        value: null
                    },
                    {
                        name: 'Quality',
                        value: null
                    },
                    {
                        name: 'Materials',
                        value: null
                    },
                    {
                        name: 'Sales & Marketing',
                        value: null
                    },
                    {
                        name: 'Other',
                        value: null
                    }
                ],
                recalls: [
                    {
                        name: 'Design Engineering',
                        value: null
                    },
                    {
                        name: 'Purchasing',
                        value: null
                    },
                    {
                        name: 'Production',
                        value: null
                    },
                    {
                        name: 'Accounting',
                        value: null
                    },
                    {
                        name: 'Finance',
                        value: null
                    },
                    {
                        name: 'Quality',
                        value: null
                    },
                    {
                        name: 'Materials',
                        value: null
                    },
                    {
                        name: 'Sales & Marketing',
                        value: null
                    },
                    {
                        name: 'Other',
                        value: null
                    }
                ],
                fieldServices: [
                    {
                        name: 'Design Engineering',
                        value: null
                    },
                    {
                        name: 'Purchasing',
                        value: null
                    },
                    {
                        name: 'Production',
                        value: null
                    },
                    {
                        name: 'Accounting',
                        value: null
                    },
                    {
                        name: 'Finance',
                        value: null
                    },
                    {
                        name: 'Quality',
                        value: null
                    },
                    {
                        name: 'Materials',
                        value: null
                    },
                    {
                        name: 'Sales & Marketing',
                        value: null
                    },
                    {
                        name: 'Other',
                        value: null
                    }
                ],
                afterDelivery: [
                    {
                        name: 'Design Engineering',
                        value: null
                    },
                    {
                        name: 'Purchasing',
                        value: null
                    },
                    {
                        name: 'Production',
                        value: null
                    },
                    {
                        name: 'Accounting',
                        value: null
                    },
                    {
                        name: 'Finance',
                        value: null
                    },
                    {
                        name: 'Quality',
                        value: null
                    },
                    {
                        name: 'Materials',
                        value: null
                    },
                    {
                        name: 'Sales & Marketing',
                        value: null
                    },
                    {
                        name: 'Other',
                        value: null
                    }
                ]
            },
        }),
        methods: {
            calculateSubTotal(subCost) {
                let newTotal = 0;
                this.externalFailure[subCost].forEach(cost => {
                    if(cost.value) {
                        newTotal += parseInt(cost.value);
                    }
                })
                this.externalFailureSubTotals[subCost] = newTotal;
                this.calculateTotal();
            },
            calculateTotal() {
                let newTotal = 0;
                for(let key in this.externalFailureSubTotals) {
                    newTotal += this.externalFailureSubTotals[key]
                }
                this.externalFailureTotal = newTotal;
                this.$emit('update-total', [this.externalFailureTotal, 'externalFailure']);
            }
        },
        created: function() {
            // Add tests upon initial load here
        }
    }
</script>

<style scoped>
</style>

